import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import JobStatus from '../../../JobStatus';

function jobNumber(original) {
  if (!original?.serviceProvider) return '*****';
  return (
    <Link to={`/servicejobs/edit/${original?.id}`}>
      {original?.jobNumber || ''}
    </Link>
  );
}

function serviceCompletionDate(original) {
  return original?.serviceCompletionDate
    ? dayjs(original?.serviceCompletionDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function appointmentDate(original) {
  return original?.appointmentDate
    ? dayjs(original?.appointmentDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function serviceProvider(original) {
  return original?.serviceProvider?.accountNumber;
}

function servicePerformed(original) {
  return <ReadMoreText>{original?.servicePerformed}</ReadMoreText>;
}

function serviceJobStatus(original) {
  return <JobStatus>{original?.jobStatus}</JobStatus>;
}

export {
  jobNumber,
  appointmentDate,
  serviceProvider,
  servicePerformed,
  serviceJobStatus,
  serviceCompletionDate,
};
